/**
 * El contenido del inicio que `index.html` pidió antes de que arrancara la
 * aplicación (ahí también se precarga la primera lámina del carrusel).
 *
 * Se usa una sola vez: la primera pantalla de inicio viva lo toma y lo suelta.
 * Una pantalla abortada no lo suelta —en desarrollo, `StrictMode` monta dos
 * veces y la segunda tiene que encontrarlo— y una visita posterior al inicio
 * ya pide de nuevo, con datos frescos.
 */
import type { ContenidoInicio } from '@elcarpintero/compartido';

declare global {
  interface Window {
    __inicioAnticipado?: Promise<unknown>;
  }
}

function esContenidoInicio(valor: unknown): valor is ContenidoInicio {
  return (
    typeof valor === 'object' &&
    valor !== null &&
    Array.isArray((valor as { banners?: unknown }).banners)
  );
}

/** El contenido anticipado, o `null` si no lo hay o falló: entonces se pide. */
export async function tomarInicioAnticipado(senal?: AbortSignal): Promise<ContenidoInicio | null> {
  const anticipado = window.__inicioAnticipado;
  if (anticipado === undefined) return null;

  const datos = await anticipado;
  if (senal?.aborted !== true) delete window.__inicioAnticipado;
  return esContenidoInicio(datos) ? datos : null;
}
